import React from 'react'

import ContextProvider from '../src/components/context-provider'

const WrapWithGlobalContextProvider: React.FC<any> = ({ element }) => <ContextProvider>{element}</ContextProvider>

export default WrapWithGlobalContextProvider
